import { extractCodeDescriptionForCode } from './code-description-dictionary-utils';

const dictionaryUtils = {
  extractCodeDescriptionForCode
};

export default dictionaryUtils;
